import JQueryView from '../../../../common/views/jqueryView';
import $ from 'jquery';

export default class ShowView extends JQueryView {
  constructor() {
    super('#sb-site');

    this.setScrollFloatingFooter();
  }

  setScrollFloatingFooter() {
    $(window).on('scroll', () => {
      $('.js-floating').addClass('is-visible');
    });
  }
}
